import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from "reactstrap";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CrossIcon from  "assets/img/svg/svgComponents/CrossIcon"

// import { ignoreFilterItem } from '../constants';

import { getFilterCount } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { initialForm } from './constant';
import { getInputField } from 'components/AFilterForm/FormFields';
const Filters= ({ 
    closePopup,
    dropdownData,
    formFields,
    globalFilter,
    setGlobalFilter,
    filterCount,
    setFilterCount,
    currPageSize,
    searchHandler
}) => {

    const [filterForm, setFilterForm] = useState(initialForm);
    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value }));
    };

    useEffect(
        () => {
            setFilterForm({
                ...globalFilter,
            })
        },
        []
    );

    const handleApplyFilter = () => {
        const req = {

        }
        searchHandler({request:{...globalFilter,...filterForm}})
        let fCount = getFilterCount(filterForm);
        setFilterCount(fCount);
        setGlobalFilter((prev)=>({...prev,...filterForm}))
        closePopup()
    }
    const resetFilterForm = () => {
        setFilterForm(initialForm)
        searchHandler({...globalFilter,...initialForm})
        setGlobalFilter((prev)=>({...prev,...initialForm}))
        setFilterCount(0)
    }

    return <>
        <Card className="mb-0 regular-body label-color"
            style={{ width: "500px", borderRadius: "12px" }}>
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="regular-large-bold">Filters</div>
                    <span onClick={closePopup} className='cursor semi-bolder'><CrossIcon /></span>
                </div>

                <div className="d-flex flex-column gap-md">
                   
           <Row> {formFields?.map(formField =><Col md={6}> {getInputField(formField, filterFormHandler, filterForm)}</Col>)}</Row>
                    <div className="mt-3 d-flex flex-row-reverse justify-content-between">
                        <AButton
                            variant="primary_filled"
                            className="button_remove_left_margin"
                            onClick={() => {
                                handleApplyFilter();
                            }}
                            disabled={!getFilterCount({ ...filterForm })}
                        >
                            Apply
                        </AButton>

                        {filterCount > 0 && (
                            <AButton
                                variant="danger_filled"
                                className="button_remove_left_margin"
                                // updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                                onClick={resetFilterForm}
                            >
                                Reset
                            </AButton>
                        )}
                    </div>
                </div>
            </CardBody>
        </Card>
    </>
}
export default Filters;
